import { useEffect, useRef } from "react";
import Footer from "../../components/common/layout/Footer";
import HeroSection from "../../components/features/home/HeroSection";
import DiscoverFuture from "../../components/features/home/DiscoverFuture";
import Career from "../../components/features/home/Career";
import AffiliationsCarousel from "../../components/features/home/Affiliations";
import { NeuralNetworkBackground } from "../../components/features/home/HeroSection";
import DigitalOperating from "../../components/features/home/DigitalOperating";
import Projects from "../../components/features/home/Projects";
import TestPage from "@/pages/TestPage";
import SEO from "@/components/common/seo/seo";

const SECTION_IDS = ["start", "about", "capabilities", "projects", "digital", "career", "partners"];

export default function Home() {
  const footerRef = useRef<HTMLElement>(null);

  // Track which section is active and dispatch sectionchange
  useEffect(() => {
    const observers: IntersectionObserver[] = [];

    SECTION_IDS.forEach((id, index) => {
      const el = document.getElementById(id);
      if (!el) return;

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            window.dispatchEvent(new CustomEvent("sectionchange", { detail: { index } }));
          }
        },
        { threshold: 0.5 }
      );

      observer.observe(el);
      observers.push(observer);
    });

    return () => observers.forEach((o) => o.disconnect());
  }, []);

  // Footer visibility events for sidebar hide/show
  useEffect(() => {
    const footer = footerRef.current;
    if (!footer) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          window.dispatchEvent(new CustomEvent("footer:enter"));
        } else {
          window.dispatchEvent(new CustomEvent("footer:leave"));
        }
      },
      { threshold: 0.1 }
    );

    observer.observe(footer);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <SEO
        title="SAN micron | Software Development & IT Solutions Company"
        description="SAN micron is a trusted software development and IT solutions company offering web development, mobile apps, cloud solutions, and digital transformation services."
      />

      <div>
        <section id="start" className="relative overflow-hidden">
          <NeuralNetworkBackground />
          <HeroSection />
        </section>

        <section id="about" className="md:px-24">
          <DiscoverFuture />
        </section>

        <section>
          <TestPage />
        </section>

        <section id="projects" className="md:px-24">
          <Projects />
        </section>

        <section id="digital" className="md:px-24">
          <DigitalOperating />
        </section>

        <section id="career" className="md:px-24">
          <Career />
        </section>

        <section id="partners" className="flex flex-col">
          <AffiliationsCarousel />
          <footer ref={footerRef}>
            <Footer />
          </footer>
        </section>
      </div>
    </>
  );
}